import { faTreePalm } from '@fortawesome/pro-solid-svg-icons'
import { useDateTimeToLocaleString } from '@hooks/useDateTimeWithLocale'
import { isLeave } from '@utils/absence'
import { useFormatStartAndEnd } from '@utils/dates'
import { secondsToTimestamp } from '@utils/time'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailItem } from './DetailItem'

interface Props {
  absence: Absence
}

export const AbsenceItem: FC<Props> = ({ absence }) => {
  const { t } = useTranslation()
  const toLocaleString = useDateTimeToLocaleString()
  const formatStartAndEnd = useFormatStartAndEnd(toLocaleString)

  // Leave absences span a date range; time off is a duration on a single day.
  const value = isLeave(absence)
    ? formatStartAndEnd(absence.startDate, absence.estimatedEndDate)
    : `${secondsToTimestamp(absence.duration)} ${t('common.hours')}`

  return (
    <DetailItem
      icon={faTreePalm}
      variant="timeOff"
      heading={absence.type}
      subheading={
        isLeave(absence) ? t('features.timeLogging.leave') : undefined
      }
      value={value}
    />
  )
}
